$(document).ready(function () {
    if(document.querySelector('.goSearch_monitor')){
        document.querySelector('.goSearch_monitor').onkeyup = function(e) {
            if (e.keyCode === 13) {
                document.querySelector('.goSearch_form').submit();
            }
            return true;
        }
    }
});